import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache) {
  var _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createBlock(_component_router_view);
}